import React from 'react';
import ReactDOM from 'react-dom';
import './output.css'; // Tailwind CSS
import './footer.css';
import App from './App';
import { transitions, positions, Provider as AlertProvider } from 'react-alert';
import AlertTemplate from 'react-alert-template-basic';
import { HelmetProvider } from "react-helmet-async"; // ✅ ADD THIS
import { Provider } from 'react-redux';
import Store from './Component/Store';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from "@material-tailwind/react"; // <-- ADD THIS
import '@fontsource/bebas-neue';
import '@fontsource/manrope/300.css';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/700.css';

const options = {
  position: positions.BOTTOM_CENTER,
  timeout: 5000,
  offset: '30px',
  transition: transitions.SCALE,
};

ReactDOM.render(
  <Provider store={Store}>
    <AlertProvider template={AlertTemplate} {...options}>
      <BrowserRouter>
        <HelmetProvider> {/* ✅ THIS IS REQUIRED */}
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </HelmetProvider>
      </BrowserRouter>
    </AlertProvider>
  </Provider>,
  document.getElementById("root")
);
